import React, {useContext, useState} from "react"
import {useTranslation} from "next-i18next"
import {Form, Formik} from "formik"
import {useRouter} from "next/router"
import * as Yup from "yup"
import Typography from "../../../reusable/Typography/Typography"
import {suggestionFormQuizHandler} from "../../../../utility/postHandler"
import FormInput from "../../../reusable/FormInput/FormInput"
import {QuizzContext} from "../../../../context/QuizzContext"
import {ArrowLeft} from "react-bootstrap-icons"
import MoreWaysToFindEbikeQuizCta from "../MoreWaysToFindEbikeQuizCta"
import {filterUrl} from "../../../filter/FilterUrl"
import urlParams from "../../../../utility/UrlParams"
import PhoneInput from "../../../supersaverLandingPage/components/PhoneInput"
import Button from "../../../reusable/components/Button"

interface MyFormValues {
    firstname: string;
    lastname: string;
    email: string;
    "0-2/phone": string;
    countryCode: string;
    recommendation_link: string;
}

const schema = Yup.object().shape({
	firstname: Yup.string().required("Required"),
	lastname: Yup.string().required("Required"),
	email: Yup.string().email("Invalid email").required("Required"),
	"0-2/phone": Yup.string().required("Required"),
	countryCode: Yup.string().required("Required"),
	recommendation_link: Yup.string().required("Required")
})

function QuizForm() {
	const router = useRouter()
	const currentUrl = router.asPath
	const {t} = useTranslation()
	const [formSubmitted, setFormSubmitted] = useState(false)
	const {setActiveQuizz, parseQuizData, quizzData} = useContext(QuizzContext)
	const initialValues: MyFormValues = {
		firstname: "",
		lastname: "",
		email: "",
		"0-2/phone": "",
		countryCode: "(+41)",
		recommendation_link: `${process.env.NEXT_PUBLIC_APP_URL}${filterUrl({...parseQuizData(quizzData)}, urlParams.categories, [...(quizzData?.parentCategories || []), ...(quizzData?.subCategories || [])].join(","))}`
	}

	return (
		<div style={{paddingInline: "8px"}}
			className="d-flex col-12 align-items-md-start align-items-center justify-content-start flex-column gap-0">
			<div style={{gap: "4px"}}
				className="d-flex col-12 align-items-start justify-content-start flex-column">
				<Typography style={{fontSize: "20px", lineHeight: "32px"}}
					variant="bodySmBold">{t("quiz-form-header")}</Typography>
				<Typography style={{fontSize: "14px", lineHeight: "20px"}}
					variant="bodySm">{t("quiz-form-subheader")}</Typography>
			</div>
			<Formik
				initialValues={initialValues}
				validationSchema={schema}
				onSubmit={async (values, actions) => {
					const obj = {
						formId: router?.locale === "de" ? process.env.NEXT_PUBLIC_FORM_ID_SUGGESTION_QUIZ : process.env.NEXT_PUBLIC_FORM_ID_SUGGESTION_QUIZ_FR,
						instanceId: router?.locale === "de" ? process.env.NEXT_PUBLIC_FORM_CONTACT_SUGGESTION_QUIZ : process.env.NEXT_PUBLIC_FORM_CONTACT_SUGGESTION_QUIZ_FR,
						data: values,
						context: {
							pageUri: currentUrl
						}
					}
					const response = await suggestionFormQuizHandler(obj)

					if (response.status === 200) {
						setFormSubmitted(true)
						localStorage.removeItem("quizzData")
						setActiveQuizz(prev => prev + 1)
					}

					actions.setSubmitting(false)
				}}
			>
				{({errors, touched, isSubmitting}) => (
					<div className=" col-12 justify-content-center">
						<Form className=""
							style={{marginTop: "24px"}}>
							<div className="row">
								<div className=" col-6">
									<FormInput
										labelStyle={{fontSize: "14px", lineHeight: "20px"}}
										fontStyles="bodySmBold"
										height="40px"
										name="firstname"
										label={t("Vorname")}
										required
										errColor="danger"
										className="pb-3"
										errors={errors}
										touched={touched}
									/>
								</div>
								<div className="col-6">
									<FormInput
										labelStyle={{fontSize: "14px", lineHeight: "20px"}}
										fontStyles="bodySmBold"
										height="40px"
										name="lastname"
										label={t("Nachname")}
										required
										errColor="danger"
										className="pb-3"
										errors={errors}
										touched={touched}
									/>
								</div>
							</div>
							<div className="col-12 mb-4 ">
								<PhoneInput
									labelStyle={{fontSize: "14px", lineHeight: "20px"}}
									fontVariant="bodySmBold"
									fieldHeight="40px"
									name="0-2/phone"
								/>
							</div>
							<div className="row">

								<div className="col-12 ">
									<FormInput
										labelStyle={{fontSize: "14px", lineHeight: "20px"}}
										fontStyles="bodySmBold"
										height="40px"
										name="email"
										label={t("email")}
										required
										errColor="danger"
										className="pb-3"
										errors={errors}
										touched={touched}
									/>
								</div>
							</div>

							<div className="d-flex align-items-center justify-content-start mt-2 gap-2 ">
								<ArrowLeft className="col-1 cursor-pointer"
									size={20}
									onClick={() => {
										setActiveQuizz(prev => prev - 1)
									}} />
								<div style={{flex: "1"}}>
									<Button
										disabled={isSubmitting}
										isLoading={isSubmitting}
										type="submit"
										className="btn col-12 btn-primary btn-md py-2"
										label={t("Absenden")} />

								</div>
							</div>
							<div className="px-3 my-3 container border-top col-11" />
							<MoreWaysToFindEbikeQuizCta isBlack />
						</Form>
					</div>
				)}
			</Formik>
		</div>
	)
}

export default QuizForm
